import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { useQuoteState } from 'shared/contexts';

interface SubmitConfirmationProps {
  onOk: () => void;
}
export function SubmitConfirmation({ onOk }: SubmitConfirmationProps) {
  const { confirmationOpen, toggleConfirmation } = useQuoteState();
  return (
    <Dialog open={confirmationOpen} onClose={toggleConfirmation}>
      <DialogTitle>Are you sure you want to submit?</DialogTitle>
      <DialogContent>This will lock the quote from further edits and enable the export.</DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            toggleConfirmation();
          }}
          variant='contained'
        >
          cancel
        </Button>
        <Button
          onClick={() => {
            onOk();
            toggleConfirmation();
          }}
          variant='contained'
          color='primary'
        >
          continue
        </Button>
      </DialogActions>
    </Dialog>
  );
}
